<template>
  <!-- Modal -->
  <div class="modal fade" id="modal-avaliacao" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <!-- Cabeçalho -->
        <div class="modal-header">
          <h5 class="modal-title">Realizar Avaliação</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Corpo -->
        <div class="modal-body text-center">
          <p>De 0 a 10, o quanto os KPIs do Ginfo Analytics contribuem para a tomada de decisões no seu dia a dia?</p>
          <div class="rating mb-3">
            <span v-for="rating in 10" :key="rating">
              <input type="radio" :id="'star' + rating" :value="rating" @click="selectRating(rating)">
              <label :for="'star' + rating" class="star" :class="{ 'filled': rating <= selectedRating }"></label>
            </span>
          </div>
          <p>Nota selecionada: {{ selectedRating }}</p>

          <div class="form-group mt-3">
            <label for="obsItem">Observação (Opcional):</label>
            <input v-model="observacao" type="text" class="form-control" id="obsItem">
          </div>
        </div>

        <!-- Rodapé -->
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-danger mr-2 btn-lg" @click="pularAvaliacao">Pular</button>
          <button type="button" class="btn btn-success btn-lg" @click="enviarAvaliacao"
            :disabled="disabledButton">Enviar</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
 /* eslint-disable */

export default {
  name: "ModalExterna",
  props: {
    pesquisa: {},
  },
  data() {
    return {
      selectServico: "",
      observacao: "",
      idConjunto: "",
      fornecedores: "",
      selectedRating: null,
      disabledButton: false
    };
  },
  created() {
  
  },

  computed: {

  },
  methods: {
    enviarAvaliacao() {
      if(!this.selectedRating){
        this.$swal.fire({
          title: 'Oops!',
          text: 'Informe uma nota',
          icon: 'warning'
        })
        
        return false
      }

      if(this.selectedRating <= 6 && !this.observacao){
        this.$swal.fire({
          title: 'Oops!',
          text: 'Informe uma justificativa!',
          icon: 'warning'
        })
        
        return false
      }

      const avaliacao = {
        cd_clifor: this.pesquisa.tecnicoId,
        observacao: this.observacao,
        nota: this.selectedRating,
        nr_seq_pesquisa: this.pesquisa.nr_seq_pesquisa,
        loginExterno: this.pesquisa.loginExterno
      }

      console.log(avaliacao)
      this.disabledButton = true

      this.$store.dispatch('busca/enviarAvaliacao', { data: avaliacao }).then(() => {
        $('#modal-avaliacao').modal('hide');
        window.location = '/bi/inicio'
      }).catch(error => {
        this.disabledButton = false
      })

    },

    pularAvaliacao() {
        $('#modal-avaliacao').modal('hide');
        window.location = '/bi/inicio'
    },

    executarRedirecionamento(filial) {
      if (filial.perfilMecanico == 'E') {
        this.$router.push('/osEmpilhadeira').catch(err => { console.error(err) })
      } else if (filial.fornecExt === 'S') {
        this.$router.push('/osExterna').catch(err => { console.error(err) })
      } else {
        this.$router.push('/').catch(err => { console.error(err) })
      }
    },

    selectRating(rating) {
      if (this.selectedRating === rating) {
        this.selectedRating = rating - 1;
      } else {
        this.selectedRating = rating;
      }
    }
  },

}
</script>
<style>
  #modalItems {
    pointer-events: none !important;
  }

  .close {
    display: none !important;
  }

  .star {
    font-size: 40px;
    color: #ccc;
    cursor: pointer;
  }

  .star:before {
    content: '★';
  }

  input[type="radio"] {
    display: none;
  }

  .filled:before {
    content: '★';
    color: #ffcc00;
  }
</style>